(function () {
  function makeId(prefix) {
    return prefix + '_' + Math.random().toString(36).slice(2) + Date.now().toString(36);
  }

  function stableId(key, prefix) {
    var value = window.localStorage.getItem(key);
    if (!value) {
      value = makeId(prefix);
      window.localStorage.setItem(key, value);
    }
    return value;
  }

  function attribution() {
    var search = new URLSearchParams(window.location.search);
    return {
      utm_source: search.get('utm_source') || '',
      utm_medium: search.get('utm_medium') || '',
      utm_campaign: search.get('utm_campaign') || '',
      utm_content: search.get('utm_content') || '',
      referrer: document.referrer || ''
    };
  }

  function storeEvent(event) {
    var key = 'b2h_validation_events';
    var current = [];
    try {
      current = JSON.parse(window.localStorage.getItem(key) || '[]');
    } catch (error) {
      current = [];
    }
    current.push(event);
    window.localStorage.setItem(key, JSON.stringify(current.slice(-200)));
  }

  function publishEvent(event) {
    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      try {
        window.Shopify.analytics.publish('b2h_validation_event', event);
      } catch (error) {
        // Local storage remains the QA fallback when no custom pixel subscribes.
      }
    }
  }

  function createTracker(root) {
    var visitorId = stableId('b2h_validation_visitor_id', 'v');
    var sessionId = window.sessionStorage.getItem('b2h_validation_session_id');
    if (!sessionId) {
      sessionId = makeId('s');
      window.sessionStorage.setItem('b2h_validation_session_id', sessionId);
    }

    return function track(name, properties) {
      var event = {
        event_name: name,
        page_slug: root.dataset.pageSlug || '',
        test_id: root.dataset.testId || '',
        created_at: new Date().toISOString(),
        visitor_id: visitorId,
        session_id: sessionId,
        qa: attribution().utm_medium === 'qa',
        properties: Object.assign(attribution(), properties || {})
      };
      storeEvent(event);
      publishEvent(event);
    };
  }

  function populateAttribution(root) {
    var values = attribution();
    root.querySelectorAll('[data-utm-field]').forEach(function (field) {
      field.value = values[field.dataset.utmField] || '';
    });
    var qaField = root.querySelector('[data-qa-field]');
    if (qaField) qaField.value = values.utm_medium === 'qa' ? 'yes' : 'no';
  }

  function selectedAnswers(form) {
    var answers = {};
    form.querySelectorAll('select').forEach(function (field) {
      var key = field.name.replace(/^contact\[|\]$/g, '').toLowerCase().replace(/\s+/g, '_');
      answers[key] = field.value;
    });
    return answers;
  }

  function initRoot(root) {
    if (root.dataset.trackingReady === 'true') return;
    root.dataset.trackingReady = 'true';
    var track = createTracker(root);

    populateAttribution(root);
    track('landing_view', { viewport_width: window.innerWidth, viewport_height: window.innerHeight });

    root.querySelectorAll('[data-track]').forEach(function (node) {
      node.addEventListener('click', function () {
        track(node.dataset.track, {
          cta_text: node.textContent.trim(),
          section: node.dataset.section || ''
        });
      });
    });

    var form = root.querySelector('.b2h-validation__form');
    if (form) {
      form.addEventListener('submit', function () {
        track('email_submit_attempt', selectedAnswers(form));
      });
    }

    var success = root.querySelector('[data-validation-submit-success]');
    if (success) {
      var successKey = 'b2h_validation_success_' + root.dataset.testId;
      if (window.sessionStorage.getItem(successKey) !== 'true') {
        track('email_submit_success', {});
        window.sessionStorage.setItem(successKey, 'true');
      }
    }

    var scrollTracked = false;
    function onScroll() {
      if (scrollTracked) return;
      var maxScroll = document.documentElement.scrollHeight - window.innerHeight;
      if (maxScroll > 0 && window.scrollY / maxScroll >= 0.75) {
        scrollTracked = true;
        track('scroll_75', {});
        window.removeEventListener('scroll', onScroll);
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function init() {
    document.querySelectorAll('[data-b2h-validation]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
